import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PartService } from '../../../service/api/part-service';
import { redux } from 'Core/redux';

export const STORE_KEY = 'part';
export const INITIAL_STATE = {
  data: [],
  loading: false,
  error: null,
};

export const fetchParts = createAsyncThunk('status/fetchParts', async () => {
  const { response } = await PartService.getAllParts();
  return response;
});

export const fetchPartsForInspectionPlan = createAsyncThunk('part/fetchPartsForInspectionPlan', async (status = 'In Production') => {
  const { response } = await PartService.getPartsForInspectionPlan(status);
  return response;
});

export const fetchPartsForQualityInspection = createAsyncThunk('part/fetchPartsForQualityInspection', async () => {
  const { response } = await PartService.getAllPartsForQualityInspection();
  return response;
});

export const { reducer, actions } = createSlice({
  name: STORE_KEY,
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchParts.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchParts.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchParts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchPartsForInspectionPlan.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPartsForInspectionPlan.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPartsForInspectionPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchPartsForQualityInspection.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPartsForQualityInspection.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPartsForQualityInspection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

redux.injectReducer(STORE_KEY, reducer);
